import { Button, useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import BrandsTable from '../../../components/Brands/BrandsTable.js';
import { columnsDataBrands } from './variables/columnsDataBrand.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js'; // Asegúrate de importar postData
import { useSearch } from '../../../contexts/SearchContext.js';
import BrandsEditModal from '../../../components/Brands/BrandsEditModal.js'; // Asegúrate de importar el modal
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';

export default function Settings() {
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [modalState, setModalState] = useState({ isOpen: false, brand: null, isNew: false });
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);


  const loadData = async (dato) => {
    try {
      const params = new URLSearchParams({
        page: String(page + 1),
        limit: String(rowsPerPage),
        data: dato || '',
      });
      appendSortParams(params);
      const response = await getData(`/brands?${params.toString()}`);
      setData(response?.payload?.brands || []); // Actualiza los datos
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      console.error('Error fetching brands:', error);
    }
  };

  useEffect(() => {
    loadData(searchQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openNewBrandModal = () => {
    setModalState({ isOpen: true, brand: null, isNew: true });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, brand: null, isNew: false });
  };

  // Función para crear un nuevo brand
  const handleCreateBrand = async (newBrand) => {
    try {
      await postData('/brands', newBrand); 
      loadData(searchQuery);
    } catch (error) {
      toast({
        title: 'Error al obtener marcas',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Función para actualizar un brand
  const handleUpdateBrand = async (updatedBrand) => {
    try {
      await putData(`/brands/${updatedBrand.id}`, updatedBrand); // Actualiza el brand en la API
      await loadData(searchQuery); 
      closeEditModal(); 
    } catch (error) {
      toast({
        title: 'Error al actualizar el brand',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <AdminPageShell
      title="Marcas"
      actions={
        <Button variant="adminPrimary" size="sm" onClick={openNewBrandModal}>
          Nueva marca
        </Button>
      }
    >
      <BrandsTable
          columnsData={columnsDataBrands}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateBrand={handleUpdateBrand}
          sorting={sorting}
          onSortingChange={setSorting}
        />


      <BrandsEditModal
        isOpen={modalState.isOpen}
        onClose={closeEditModal}
        color={modalState.brand}
        isNew={modalState.isNew}
        onCreate={handleCreateBrand} 
      />
    </AdminPageShell>
  );
}